import {
  LoadingIconButton as LoadingIconButtonBase,
  type LoadingIconButtonProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function LoadingIconButton(props: Omit<LoadingIconButtonProps, "LinkComponent">) {
  return <LoadingIconButtonBase {...props} LinkComponent={ButtonInternalLink} />;
}
